import { Unity } from "../unity";
import { PentrackerUser } from "../user/User";
import { GetGoodsControlDto } from "../../network/control/Goods";

export type NewGoodsControl = {
  id: number;
  ownerUid: string;
  unityId: number;
  entry: number;
  departure?: number;
  description: string;
  provider: string;
  guide: string;
  photo?: string;
  observation?: string;
  document?: string;
  documentType?: string;
};

export type PutGoodsControl = {
  departure?: number;
  observation?: string;
};

export type GoodsControl = Omit<GetGoodsControlDto, "timestamp"> & {
  reference: string;
  timestamp: number;
};

export type UserGoodsControl = GoodsControl & {
  unity?: Unity;
  owner?: PentrackerUser;
};

export function goodsControlDtoAsGoodsControl(
  goodsControlDto: GetGoodsControlDto,
  reference: string
): GoodsControl {
  return {
    ...goodsControlDto,
    reference,
    timestamp: goodsControlDto.timestamp.toDate().getTime(),
  };
}

export function goodsControlAsUserGoodsControl(
  goodsControl: GoodsControl,
  unity?: Unity,
  owner?: PentrackerUser
): UserGoodsControl {
  return {
    ...goodsControl,
    unity,
    owner,
  };
}
